export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const GET_PLANNING_DATA = "GET_PLANNING_DATA";
export const SET_SELECTED_CATEGORY_INDEX = "SET_SELECTED_CATEGORY_INDEX";
export const SET_SLIDE_ARRAY = "SET_SLIDE_ARRAY";
export const RESET_SELECTED_SLIDE = "RESET_SELECTED_SLIDE";
export const RESET_READY_ADD_TO_CART_LIST = "RESET_READY_ADD_TO_CART_LIST";
export const UPDATE_SAME_POSITION = "UPDATE_SAME_POSITION";
export const UPDATE_GOTO_ROW = "UPDATE_GOTO_ROW";
export const UPDATE_IS_SEND_DESIGN_CODE = "UPDATE_IS_SEND_DESIGN_CODE";
export const UPDATE_SHOW_RESULT_STATUS = "UPDATE_SHOW_RESULT_STATUS";
export const UPDATE_SHOW_GET_PRODUCTION_JSON_MODAL =
    "UPDATE_SHOW_GET_PRODUCTION_JSON_MODAL";
export const UPDATE_SHOW_PRODUCTION_LIST_MODAL =
    "UPDATE_SHOW_PRODUCTION_LIST_MODAL";
export const UPDATE_SHOW_POST_PRODUCTION_JSON_MODAL =
    "UPDATE_SHOW_POST_PRODUCTION_JSON_MODAL";
export const UPDATE_SHOW_ADD_TO_CART_PRODUCT_LIST_MODAL =
    "UPDATE_SHOW_ADD_TO_CART_PRODUCT_LIST_MODAL";
export const UPDATE_SIMPLE_PRODUCT_DATA = "UPDATE_SIMPLE_PRODUCT_DATA";
export const UPDATE_LIST_DATA_JSON = "UPDATE_LIST_DATA_JSON";
export const POST_SIMPLE_PRODUCT_API = "POST_SIMPLE_PRODUCT_API";
export const UPDATE_TOTAL_AMOUNT = "UPDATE_TOTAL_AMOUNT";
export const UPDATE_READY_ADD_TO_CART_LIST = "UPDATE_READY_ADD_TO_CART_LIST";
export const UPDATE_ALREADY_ADD_TO_CART_LIST =
    "UPDATE_ALREADY_ADD_TO_CART_LIST";
export const UPDATE_READY_ADD_TO_CAR_LIST = "UPDATE_READY_ADD_TO_CAR_LIST";
export const POST_ADD_TO_CART_API = "POST_ADD_TO_CART_API";
export const POST_SAVE_STATUS_API = "POST_SAVE_STATUS_API";
export const GET_SAVE_STATUS_API = "GET_SAVE_STATUS_API";

// getJsonUpdate
export const UPDATE_SELECTED_CATEGORY_INDEX = "UPDATE_SELECTED_CATEGORY_INDEX";
export const UPDATE_SELECTED_STATE = "UPDATE_SELECTED_STATE";
